// Cloudflare Workers public endpoints support HTTPS. Never rewrite arbitrary
// HTTP sources, local streaming servers, or explicit custom ports.
function secureStream(stream) {
    if (!stream || typeof stream.url !== 'string') return stream;
    let url;
    try {
        url = new URL(stream.url);
    } catch (_) {
        return stream;
    }
    if (url.protocol !== 'http:' || !url.hostname.endsWith('.workers.dev') ||
        url.port || url.username || url.password) return stream;
    return { ...stream, url: stream.url.replace(/^http:/i, 'https:') };
}

module.exports = secureStream;
